import {SxProps, Theme} from '@mui/material/styles';

const styles = {
  container: {
    backgroundColor: '#FFFFFF',
    width: {
      sm: '548px',
      xs: '90vw',
    },
    borderRadius: '16px',
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    height: '100%',
    overflow:"auto",
  },
  box: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  primary: {
    fontSize: {
      xs: '24px',
      sm: '32px',
    },
    fontWeight: 500,
    color: '#000000',
    letterSpacing: '-0.8px',
    marginBottom: '8px',
  },
  secondary: {
    fontSize: {
      xs: '14px',
      sm: '17px',
    },
    fontWeight: 400,
    color: '#000000',
    letterSpacing: '-0.4px',
  },
  btn: {
    'backgroundColor': '#2D2D2D',
    'color': '#FFFFFF',
    'fontSize': {
      xs: '15px',
      sm: '17px',
    },
    'fontWeight': 400,
    'letterSpacing': '-0.4px',
    'boxShadow': '0px 8px 32px 0px #00000033',
    'transition':
      'box-shadow 0.4s ease-in-out, color 0.4s ease-in-out, transform 0.1s',
    '&:hover': {
      color: '#2D2D2D',
      backgroundColor: '#2D2D2D',
      border: '1px solid #BABAC8',
      boxShadow:
        '0px 8px 32px 0px #00000033, inset -485px 0 0 0 rgba(255, 255, 255, 1)',
    },
    '&:active': {
      transform: 'scale(1.1, 1.1)',
    },
  },
};

export default styles as Record<keyof typeof styles, SxProps<Theme>>;
